<header class="py-1" *ngIf="showAlax">
    <div class="container">
        <div class="d-flex w-100 justify-content-end">
        <div class="links">
            <!-- <span (click)="goToCustomer()" class="pointer" routerLinkActive="active">{{'menu.local_access' | translate}}</span> -->
            <span  class="mx-3 pointer" (click)="goToFaqs()" routerLinkActive="active">{{'menu.faq' | translate}}</span>
            <span  class="pointer" (click)="goToContact()" routerLink="/contacto" routerLinkActive="active">{{'menu.contact' | translate}}</span>
        </div></div>
    </div>
</header> 